import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { CategoriesResultTaxonomy, ProductResultTaxonomy } from '../../taxonomy/Taxonomies.js';

var MAX_NUMBER_OF_RESULTS = 8;
var MAX_NUMBER_OF_RESULTS_PER_SECTION = 4;
var resultPosition = 0;
var generateResultSections = function generateResultSections(calculateItemsToShowInput) {
  var _algoliaResponse$Cate, _algoliaResponse$Cate2, _algoliaResponse$Prod, _algoliaResponse$Prod2;
  var algoliaResponse = calculateItemsToShowInput.algoliaResponse,
    locale = calculateItemsToShowInput.locale,
    pageName = calculateItemsToShowInput.pageName;
  var categories = (_algoliaResponse$Cate = (_algoliaResponse$Cate2 = algoliaResponse[CategoriesResultTaxonomy.id]) === null || _algoliaResponse$Cate2 === void 0 || (_algoliaResponse$Cate2 = _algoliaResponse$Cate2.response) === null || _algoliaResponse$Cate2 === void 0 ? void 0 : _algoliaResponse$Cate2.results) !== null && _algoliaResponse$Cate !== void 0 ? _algoliaResponse$Cate : [];
  var products = (_algoliaResponse$Prod = (_algoliaResponse$Prod2 = algoliaResponse[ProductResultTaxonomy.id]) === null || _algoliaResponse$Prod2 === void 0 || (_algoliaResponse$Prod2 = _algoliaResponse$Prod2.response) === null || _algoliaResponse$Prod2 === void 0 ? void 0 : _algoliaResponse$Prod2.results) !== null && _algoliaResponse$Prod !== void 0 ? _algoliaResponse$Prod : [];
  var resultSections = [];
  var maxNumberOfCategories = calculateMaxNumberOfItems(products);
  var maxNumberOfProducts = calculateMaxNumberOfItems(categories);
  var totalItems = Math.min(categories.length + products.length, MAX_NUMBER_OF_RESULTS);
  resultPosition = 0;
  AddResultSection(categories, CategoriesResultTaxonomy, resultSections, locale, maxNumberOfCategories, pageName, totalItems);
  AddResultSection(products, ProductResultTaxonomy, resultSections, locale, maxNumberOfProducts, pageName, totalItems);
  return {
    resultSections: resultSections,
    maxNumberOfCategories: maxNumberOfCategories,
    maxNumberOfProducts: maxNumberOfProducts
  };
};
var calculateMaxNumberOfItems = function calculateMaxNumberOfItems(results) {
  return results.length >= MAX_NUMBER_OF_RESULTS_PER_SECTION ? MAX_NUMBER_OF_RESULTS_PER_SECTION : MAX_NUMBER_OF_RESULTS - results.length;
};
var getItemsToShow = function getItemsToShow(input) {
  var results = input.results,
    taxonomy = input.taxonomy,
    maxNumberOfResults = input.maxNumberOfResults,
    sectionPosition = input.sectionPosition,
    pageName = input.pageName,
    totalItems = input.totalItems;
  return results.slice(0, maxNumberOfResults).map(function (result, index) {
    var trackingInformation = getTrackingInformation({
      sectionName: taxonomy.id,
      pageName: pageName,
      totalItems: totalItems,
      sectionPosition: sectionPosition,
      searchItem: result,
      index: index
    });
    resultPosition++;
    var resultSectionItem = _objectSpread2(_objectSpread2({}, result), {}, {
      trackingInformation: trackingInformation
    });
    return resultSectionItem;
  });
};
var getTrackingInformation = function getTrackingInformation(input) {
  var sectionName = input.sectionName,
    pageName = input.pageName,
    totalItems = input.totalItems,
    sectionPosition = input.sectionPosition,
    searchItem = input.searchItem,
    index = input.index;
  var trackingInformation = {
    eventData: {
      sectionName: sectionName,
      sectionPosition: sectionPosition,
      resultPosition: resultPosition,
      location: window.location.pathname,
      resultId: searchItem.objectID,
      position: index + 1,
      list_section_id: sectionName
    },
    auxiliaryData: {
      pageName: pageName,
      totalItems: totalItems
    }
  };
  return trackingInformation;
};
function AddResultSection(results, taxonomy, itemsToShow, locale, maxNumberOfResultsToInclude, pageName, totalItems) {
  if (results.length === 0) {
    return;
  }
  var resultsSection = {
    name: taxonomy.localizedHeader ? taxonomy.localizedHeader(locale) : undefined,
    taxonomyId: taxonomy.id,
    items: getItemsToShow({
      results: results,
      taxonomy: taxonomy,
      maxNumberOfResults: maxNumberOfResultsToInclude,
      pageName: pageName,
      totalItems: totalItems,
      sectionPosition: 1
    })
  };
  itemsToShow.push(resultsSection);
}

export { generateResultSections };
//# sourceMappingURL=querySuggestionItemsCalculator.js.map
